import { render, staticRenderFns } from "./emergencyNotice.vue?vue&type=template&id=162ce62d&scoped=true&"
import script from "./emergencyNotice.vue?vue&type=script&lang=js&"
export * from "./emergencyNotice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162ce62d",
  null
  
)

export default component.exports